import React from "react";

import { getJarisMerchantPortfolioUrl } from "globalConstants";

import { LinkPill } from "./linkPill";

import { ReactComponent as JarisLogo } from "static/images/jaris_logo.svg";

type JarisButtonProps = {
	jarisMerchantId: string;
	jarisShopId: string;
	value?: string;
};

export const JarisButton = ({
	jarisMerchantId,
	jarisShopId,
	value = "Merchant account",
}: JarisButtonProps) => {
	const href = getJarisMerchantPortfolioUrl(jarisMerchantId, jarisShopId);

	// Without a target the pill would be a dead link, so show nothing instead.
	if (!href) return null;

	return <LinkPill icon={<JarisLogo />} label={value} href={href} />;
};
